module.exports = __webpack_public_path__ + "img/adrift-in-the-harbor-2.17b0fa23.webp";